<template>
  <main>
    <h1
      v-show="coupon.name"
      class="pb-3 text-center price-text-disabled"
    >
      ${{ (planPrice/100).toFixed(2) }}/month
    </h1>
    <h1 class="text-center">
      <span
        v-show="coupon.amount_off"
        class="label text-success"
      >{{ couponAmountOff }}</span>
    </h1>
    <h1 class="text-center">
      <span
        v-show="coupon.percent_off"
        class="label text-success"
      >{{ couponPctOff }}</span>
    </h1>
    <h2 class="text-center">
      <span
        v-show="couponDuration"
        class="label text-success"
      >{{ couponDuration }}</span>
    </h2>
    <h1 class="pb-3 text-center price-text">
      {{ currentPrice }}
    </h1>
    <form
      id="payment-form"
      ref="form"
      class="col-12"
      @submit.prevent="processPayment"
    >
      <div class="form-group">
        <div>
          <label
            for="card-element"
            class="col-form-label"
          >
            Enter Credit or Debit Card
          </label>
                    
          <div
            ref="card"
            class="form-control form-control-lg card-input"
          >
            <!-- A Stripe Element will be inserted here. -->
          </div>
        </div>
      </div>
      <div
        v-show="showCouponField"
        class="form-group d-flex flex-column"
      >
        <div class="d-flex">
          <input
            v-model="coupon.id"
            type="text"
            class="form-control form-control-lg coupon-input"
            placeholder="Enter Coupon"
          >
          <button
            class="btn btn-success ml-1"
            @click.prevent="applyCoupon"
          >
            Apply
          </button>
        </div>
        <div
          v-show="coupon.error"
          class="error p-2"
        >
          {{ coupon.error }}
        </div>
      </div>
      <!-- Used to display Element errors. -->
      <div
        id="card-errors"
        role="alert"
        class="error p-2"
      >
        {{ cardError }}
      </div>
      <div class="form-group">
        <button
          class="btn btn-primary btn-lg btn-block"
          type="submit"
          :disabled="processingPmt"
        >
          <div
            v-show="processingPmt"
            class="spinner-border text-light"
          />
          <div v-show="!processingPmt">
            Submit
          </div>
        </button>
        <button
          class="btn btn-outline-dark btn-lg btn-block"
          @click="$router.push('/account/subscriptions')"
        >
          Cancel
        </button>
      </div>
    </form>
  </main>
</template>

<script>
import Coupon from '../services/coupons.js';
export default {
  props: {
    submit: Function,
    showCouponField: {
      type: Boolean,
      default: true,
    }
  },
  data: () => {
    return {
      card: {},
      elements: {},
      stripe:{},
      planPrice: 499,
      coupon: {
        id: null,
        name: null,
        duration: null,
        duration_in_months: null,
        amount_off: null,
        percent_off: null,
        redeem_by: null,
        valid: null,
        error:null,
      },
      formData: {
        name: null,
        address_line1: null,
        address_line2: null,
        address_city: null,
        address_state: null,
        address_zip: null
      },
      cardError: '',
      processingPmt: false,
    }
  },
  computed: {
    couponId(){
      // ensures we pass valid coupon id on subscription update
      return this.coupon.valid ? this.coupon.id : null;
    },
    currentPrice(){
      if (this.coupon.amount_off) {
        let price = ((this.planPrice - this.coupon.amount_off)/100).toFixed(2);
        return `$${price}/month`
      } else if (this.coupon.percent_off) {
        let price = ((this.planPrice * (this.coupon.percent_off/100))/100).toFixed(2);
        return `$${price}/month`;
      }   else {
        return `$${(this.planPrice/100).toFixed(2)}/month`;
      }
    },
    couponDuration(){
      if (this.coupon.duration === 'once'   )   return 'your first month!';
      if (this.coupon.duration === 'forever')   return 'FOREVER';
      if (this.coupon.duration === 'repeating') return `for ${this.coupon.duration_in_months} months!`;
    },
    couponAmountOff(){
      let amt = (this.coupon.amount_off/100).toFixed(2);
      return `$${amt} OFF`;
    },
    couponPctOff(){
      return `${this.coupon.percent_off}% OFF`;
    },
  },
  mounted: function () {
    this.initStripe();
  },
  destroyed(){
    this.card.removeAllListeners();
    this.card.unmount();
  },
  methods: {
    applyCoupon(){
      Coupon.validate(this.coupon.id).then(res =>{
        // res should contain coupon meta data if valid
        this.coupon = res;
      }).catch(err => {
        // err should equate to coupon not found or not valid
        this.coupon.error = err.response.data.errors.coupon.join(', ');
      })
    },
    initStripe(){
      this.stripe = Stripe(window.STRIPE_KEY);
      let style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '1.1em',
          fontWeight: '100',
        }
      };
      this.elements = this.stripe.elements();
      this.card = this.elements.create('card', {style: style});
      this.card.mount(this.$refs.card);
      let vm = this;
      this.card.addEventListener('change', function (event) {
        vm.cardError = event.error ? event.error.message : '';
      });
    },
    processPayment () {
      this.processingPmt = true;
      let self = this;
      this.stripe.createToken(this.card).then(function(result) {
        if (result.error) {
          self.cardError = result.error;
          self.processingPmt = false;
          return;
        } else {
          // now that we have a stripe token we need to hit the backend and actually create a
          // subscription with stripe
          // to do that we have to use function in parent component that has been
          // passed in as prop called 'submit'
          self.submit(result.token, self.couponId);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
    .error {
        color: red;
    }
    .card-input {
        padding-top: .6em;
    }
    .coupon-input {
        font-size: 1.1em;
    }
    .price-text {
        font-size: 2.8em;

        &-disabled {
            text-decoration: line-through;
            color: red;
            font-style: italic;
        }
    }
</style>
